export default __webpack_public_path__ + "static/media/eth.cabd9260.svg";